(function documentTypeFromTemplateControllerDefinition() {
    'use strict';

    angular.module('DocumentType')
        .controller('DocumentTypeFromTemplateController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', '$stateParams', 'adminDocumentTypeService', 'authExtend',
        function documentTypeFromTemplateController($scope, config, $state, $translate, errors, $stateParams, adminDocumentTypeService, authExtend) {

            $scope.title = 'DocumentTypeFromTemplateTitle';

            $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

            adminDocumentTypeService.getById($stateParams.id, 'Put').then(function (result) {
                $scope.documentType = angular.copy(result);
                $scope.documentType.template = false;
                $scope.documentType.parentDocumentType = result;
                delete $scope.documentType.id;

                $scope.documentType.name = '';
                $scope.documentType.systemName = '';

            }, function (error) {
                errors.showError(error);
                $state.go('document-type-find');
            });

            $scope.save = function () {

                if (!$scope.documentTypeForm.$valid) {
                    $scope.documentTypeForm.$setSubmitted();
                    errors.showError('VerifyFormData');
                    return;
                }

                adminDocumentTypeService.create($scope.documentType).then(function (result) {

                    var documentType = result;

                    if (documentType && documentType.id) {
                        $state.go('document-type-metadata', { id: documentType.id });
                    }
                    else {
                        $state.go('document-type-find');
                    }
                },
                    function (error) {
                        errors.showError(error);
                    });
            };

            $scope.cancel = function () {
                $state.go('document-type-find');
            };

        }
        ]);
})();